import * as React from 'react'
import Table from '../../../../common/src/components/Table'
import TableMultiselect from '../../../../common/src/components/TableMultiselect'
import { ColoredSpan, BodyTextSpan } from '../../../../common/src/components/core'
import { dateMDYFmt } from '../../../../common/src/date'
import { FetchFirmTasksQuery, UpdateTasksMutation } from '../../../../common/src/types.gen'
import { TaskLink } from '../components/task'

type Task = FetchFirmTasksQuery['firm']['tasks'][0] | UpdateTasksMutation['bulkUpdateTasks'][0]

interface TasksTMultiSelProps {
  tasks: Task[]
  onChange?: (keys: Set<string | number>) => void
  as: 'Table' | 'TableMultiselect'
  widths?: (string | null)[]
  alignments?: (string | null)[]
}

/**
 * See TableMultiselect.
 *
 * Provides multiselect table for a list of tasks.
 */
export class TasksTable extends React.PureComponent<TasksTMultiSelProps> {
  private headers = [
    'Property Name',
    <BodyTextSpan key="launch-date">Launched</BodyTextSpan>,
    <BodyTextSpan key="offboard-date">Offboarded</BodyTextSpan>,
  ]

  private colTask = (task: Task) => <TaskLink task={task} iconSize="small" />

  private colLaunchDate = (task: Task) => (
    <ColoredSpan color={task.isArchived ? 'midway' : 'silver'}>
      {task.launchDate ? dateMDYFmt(task.launchDate, 'UTC') : '—'}
    </ColoredSpan>
  )

  private colOffboardDate = (task: Task) => (
    <ColoredSpan color={task.isArchived ? 'midway' : 'silver'}>
      {task.offboardDate ? dateMDYFmt(task.offboardDate, 'UTC') : '—'}
    </ColoredSpan>
  )

  private cols = [this.colTask, this.colLaunchDate, this.colOffboardDate]

  private tasksTableGetId = (task: Task) => task.id

  render() {
    const { tasks, onChange, as, widths, alignments } = this.props

    if (as === 'TableMultiselect') {
      return (
        <TableMultiselect
          rows={tasks}
          columns={this.cols}
          headers={this.headers}
          widths={widths}
          alignments={alignments}
          onChange={onChange}
          keyFn={this.tasksTableGetId}
        />
      )
    } else {
      return (
        <Table
          rows={tasks}
          columns={this.cols}
          headers={this.headers}
          widths={widths}
          alignments={alignments}
          keyFn={this.tasksTableGetId}
        />
      )
    }
  }
}
